(function ($)
{
    /// <summary>
    /// jQuery UI widget for managing a mini calendar section.
    /// </summary>
    $.widget("ui.MiniCalendar",
    {
        options:
        {
            /// <summary>
            /// Callback function used to merge in extra post database to to SelectMonthUrl.
            /// Callback is to returned the merged data.
            /// function (aOriginalData)
            /// </summary>
            MergeExtraPostData: null,
            SubscribeUrl: null,
            /// <summary>
            /// Url from which provides the big calendar view.
            /// </summary>
            GridUrl: null,
            /// <summary>
            /// Url from which updated events for the selected month are retrieved.
            /// </summary>
            MiniUrl: null,
            /// <summary>
            /// Initially selected month.
            /// </summary>
            SelectedMonth: null,
            /// <summary>
            /// Html to display in the mini grid area while loading new events from the server.
            /// </summary>
            LoadingHTML: '<div class="fbcms_calendar_mini_loading">'
                + '<img src="/img/spacer.gif" alt="Loading Calendar Events..." title="Loading Events..."/>'
                + '<div>Loading Events...</div>'
                + '</div><!-- .fbcms_calendar_mini_loading //-->',
            /// <summary>
            /// Html to show in the mini grid area if an error occurred loading events from the server.
            /// </summary>
            ErrorHTML: '<div class="fbcms_calendar_mini_error">'
                + '<img src="/img/spacer.gif" alt="Error Loading Calendar Events." title="Error Loading Events."/>'
                + '<div>Error Loading Events.</div>'
                + '</div><!-- .fbcms_calendar_mini_error //-->'
        },

        /// <summary>
        /// jQuery UI widget destroy.
        /// </summary>
        _destroy: function ()
        {
        },

        /// <summary>
        /// jQuery UI widget init.
        /// </summary>
        _init: function ()
        {
        },

        /// <summary>
        /// jQuery UI widget create.
        /// </summary>
        _create: function ()
        {
            var self = this;
            var jElement = $(self.element);

            jElement.on('click', '.ical_show_button',
                function (aEvent)
                {
                    aEvent.preventDefault();
                    subscribeToCalendars( self.options.SubscribeUrl );
                }
            );

            var navButtonHandler = function ( aEvent, aFocusSelector )
            {
                aEvent.preventDefault();
                var lTarget = $( aEvent.target ).closest( 'a.fbcms_calendar_mini_month_button' );
                var lLinkTarget = lTarget.data( 'target' );
                self._selectMonth( lLinkTarget, aFocusSelector );
                return false;
            };

            jElement.on('click', '.fbcms_calendar_mini_nextMonth',
                function (aEvent)
                {
                    return navButtonHandler( aEvent, '.fbcms_calendar_mini_nextMonth' );
                }
            );

            jElement.on( 'click', '.fbcms_calendar_mini_prevMonth',
                function ( aEvent )
                {
                    return navButtonHandler( aEvent, '.fbcms_calendar_mini_prevMonth' );
                }
            );

            self._setupTooltips();
        },

        _setupTooltips: function ()
        {
            var self = this;
            var jElement = $(self.element);

            $.each(
                jElement.find('.fbcms_calendar_mini_event .event_row'),
                function(aIndex, aValue)
                {
                    var lRow = $(aValue);
                    var lDetails = lRow.find('.event_details .details');
                    if (lDetails.length != 0)
                    {
                        lRow.addClass('event_details_closed');
                        lRow.attr('tabindex', "0");
                    }
                }
            );
            
            var lToggleEventRowFunc = function(aContainerElement, aRowElement)
                {
                    var jEventDetails = aRowElement.find('.event_details');
                    if (jEventDetails.length == 0)
                    {
                        return;
                    }
                    if (aRowElement.hasClass('event_details_closed'))
                    {
                        aContainerElement.find('.event_details_open').removeClass('event_details_open').addClass('event_details_closed');
                        aContainerElement.find('.details').hide();
                        aRowElement.removeClass('event_details_closed').addClass('event_details_open');
                        jEventDetails.find('.details').show();
                    }
                    else if (aRowElement.hasClass('event_details_open'))
                    {
                        aRowElement.removeClass('event_details_open').addClass('event_details_closed');
                        jEventDetails.find('.details').hide();
                    }
                };
            
            jElement.find('.fbcms_calendar_mini_event')
                    .vptooltip({
                        fetchContentElementCallback: function ( clickedObj )
                        {
                            return $(clickedObj).find('.mini_day_calendar_wrapper').get(0);
                        },
                        popoverTimeout: 10,
                        bindHackCallback: function (jPopupDiv)
                        {
                            jPopupDiv.on('click', '.event_row', function ()
                            {
                                var jEventRow = $(this);
                                lToggleEventRowFunc(jPopupDiv, jEventRow);
                            })
                            .on('keypress', '.event_row', function ( event )
                            {
                                var keycode = parseInt( event.keyCode ? event.keyCode : event.which );
                                if ( keycode === 13 )
                                {
                                    var jEventRow = $(this);
                                    lToggleEventRowFunc(jPopupDiv, jEventRow);
                                }
                            } );
                        }
                    });
        },

        Refresh: function ()
        {
            this._selectMonth(null);
        },
        /// <summary>
        /// Sets the month selected and calls the server for new data for display.
        /// Also defines the function that replaces the old data with the new.
        /// </summary>
        _selectMonth: function (aSelectedMonth, aFocusSelector)
        {
            var self = this;
            var jElement = $(self.element);
            jElement.html(self.options.LoadingHTML);

            self.options.SelectedMonth = self.GetSelectedMonth(aSelectedMonth);

            var lMyData = {
                'Month': self.options.SelectedMonth,
                'rndm': Math.random()
            };

            if (typeof self.options.MergeExtraPostData === 'function')
            {
                lMyData = self.options.MergeExtraPostData(lMyData);
            }

            $.ajax(self.options.MiniUrl, {
                success: function (data, textStatus, jqXHR)
                {
                    jElement.html(data);
                    self._setupTooltips();
                    if (aFocusSelector !== undefined)
                    {
                        jElement.find( aFocusSelector ).get( 0 ).focus();
                    }
                },
                error: function (jqXHR, textStatus, errorThrown)
                {
                    jElement.html(self.options.ErrorHTML);
                },
                data: lMyData,
                type: 'POST'
            });
        },

        /// <summary>
        /// Gets the position offset for an object.
        /// </summary>
        _getposOffset: function (what, offsettype)
        {
            var self = this;
            var jElement = $(self.element);

            var totaloffset = (offsettype == "left") ? what.offsetLeft : what.offsetTop;
            var parentEl = what.offsetParent;
            while (parentEl != null)
            {
                totaloffset = (offsettype == "left") ? totaloffset + parentEl.offsetLeft : totaloffset + parentEl.offsetTop;
                parentEl = parentEl.offsetParent;
            }
            return totaloffset;
        },
        /// <summary>
        /// Returns the current selected month.
        /// </summary>
        GetSelectedMonth: function (aDateString)
        {
            var lSelectedMonth = "";
            if (typeof aDateString === 'undefined' || aDateString == null)
            {
                lSelectedMonth = this.options.SelectedMonth;
            }
            else
            {
                lSelectedMonth = aDateString
            }
            return lSelectedMonth;
        }
    });
})(jQuery);
